import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {PricesCityAnalyticsLocation} from "./prices_city_analytics";

interface ITrackPricesCityOffersFiltersAppliedParams {
    /** District filter label exactly as the user sees it, including "Wszystkie dzielnice". */
    district: string;
    location: PricesCityAnalyticsLocation;
}

export const trackPricesCityOffersFiltersApplied = (params: ITrackPricesCityOffersFiltersAppliedParams) => {
    trackAmplitudeEvent("listing_filters_applied", {
        filter_trigger: "manual",
        location: params.location,
        district: params.district
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {PricesCityAnalyticsLocation} from "./prices_city_analytics";

interface ITrackPricesCityOffersFiltersAppliedParams {
    /** District filter label exactly as the user sees it, including "Wszystkie dzielnice". */
    district: string;
    location: PricesCityAnalyticsLocation;
}

export const trackPricesCityOffersFiltersApplied = (params: ITrackPricesCityOffersFiltersAppliedParams) => {
    trackAmplitudeEvent("listing_filters_applied", {
        filter_trigger: "manual",
        location: params.location,
        district: params.district
    });
};
